
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/housingIssue",
      function () {
        return require("private-next-pages/housingIssue/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/housingIssue"])
      });
    }
  